// extracted by mini-css-extract-plugin
export default {"socialWrapper":"Footer_socialWrapper__G3sKd","lyrzLabsO":"Footer_lyrzLabsO__gPgBb","lyrzLabsOContainer":"Footer_lyrzLabsOContainer__Zhwmr","frameParent":"Footer_frameParent__g46oa"};